export const validReferencesHeadlineTexts = [
  'References',
  'Works Cited',
  'Referenzen',
  'Bibliography',
  'Quellen',
  'Bibliographie',
];

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const referenceHeadingPattern = new RegExp(
  `<h[1-3][^>]*>\\s*(${validReferencesHeadlineTexts.map(escapeRegExp).join('|')})\\s*</h[1-3]>`,
  'i',
);

/**
 * Index of the earliest reference-section heading in the HTML, or -1.
 */
export const referenceSectionStartIndex = (text) => {
  if (!text) return -1;
  const match = text.match(referenceHeadingPattern);
  return match ? match.index : -1;
};

export const countWords = (text, ignoreReferences = true) => {
  if (!text || text === '') return 0;

  const bibliographyStartIndex = ignoreReferences ? referenceSectionStartIndex(text) : -1;
  let textWithoutBibliography = text;
  if (bibliographyStartIndex > -1) {
    textWithoutBibliography = text.substring(0, bibliographyStartIndex);
  }

  let cleanedText = textWithoutBibliography.replace(/<[^>]*>/g, ' ');
  cleanedText = cleanedText.replace(/\u00a0/g, ' ').replace(/&nbsp;/g, ' ');
  if (cleanedText.trim() === '') {
    return 0;
  }
  const words = cleanedText.trim().split(/\s+/);
  return words.length;
};

const roundHalfUpPositive = (value) => Math.round(value);

/**
 * Formal word-count bounds from task formal criteria, or null when inactive.
 * @param {{ wordcount?: number, wordcountTolerance?: number } | null | undefined} formalCriteria
 * @returns {{ min: number, target: number, max: number } | null}
 */
export const wordCountBounds = (formalCriteria) => {
  const target = formalCriteria?.wordcount ?? 0;
  const tolerance = formalCriteria?.wordcountTolerance ?? 0;
  if (target <= 0 || tolerance <= 0) {
    return null;
  }
  return {
    min: roundHalfUpPositive(target * (1 - tolerance)),
    target,
    max: roundHalfUpPositive(target * (1 + tolerance)),
  };
};

export default countWords;
